import { render, staticRenderFns } from "./dialog.user.vue?vue&type=template&id=1221eb4b&"
import script from "./dialog.user.vue?vue&type=script&lang=js&"
export * from "./dialog.user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports